<template lang="html">
  <div class="container column full-height">

    <div class="game-ww select-question container">
      <div class="game-ww__media select-question__left flex-grow-1 flex-basis-550">
        <div class="game-ww__media__img image">
          <image-loader :src="question.img" />
        </div>
        <div class="game-ww__media__audio">
          <audio-player :src="question.audio" />
        </div>
      </div>

      <div class="game-ww__question select-question__right flex-grow-2 flex-basis-450">

        <div class="select_question select_question-red container align-items-stretch">
          <div class="img container align-center">
            <img src="@/assets/img/icon-books.svg" width="30" alt="Minds" class="">
          </div>
          <div class="flex-grow-1 bordered-box bordered-box-orange">
            <p>{{ question.question }}</p>
          </div>
        </div>

        <div class="game-ww__question__words">
          <span
            v-for="(aswr, ind) in question.answers"
            :key="`answer-${ind}`"
          >
            {{ !aswr.text ? `Word ${parseInt(ind) + 1}` : aswr.text }}
          </span>
        </div>
        <div class="game-ww__question__options container align-items-center justify-content-between">
          <div class="game-ww__question__options__item">
            Use the Keyboard below
          </div>
          <button class="game-ww__question__options__item gradient-yellow color-white" :disabled="(!currentWord.text && !question.answered)"
            @click="clearWord()">
            CLEAR WORD
          </button>
          <button class="game-ww__question__options__item gradient-blue color-white" :disabled="!currentWord.text" @click="setWord()">
            NEXT WORD
          </button>
          <button class="game-cp__question__info__check btn-icon-check" type="button" name="button" :disabled="!wordsFilled" @click="answer()">
             <span>CHECK</span>
             <div class="img-check">
              <img class width="20" :src="require('@/assets/img/icons/check.svg')">
             </div>
          </button>
        </div>
        <div class="game-ww__question__keyboard container align-items-center justify-content-between">
          <!-- LIMIT 13 LETTERS -->
          <span
            v-for="(letter, ind) in currentWord.letters"
            :class="{ disabled: letter.selected }"
            @click="chooseLetter(letter)"
            :key="`letter-${ind}`"
          >
            {{ letter.letter }}
          </span>
        </div>
        <div class="game-ww__question__answer container column">

          <div class="game-ww__question__answer__item container">
            <div class="game-ww__question__answer__item__title container justify-content-center align-items-center">
              Your Word
            </div>
            <div
              class="game-ww__question__answer__item__phrase item container justify-content-start align-items-center">
              <span
                v-for="(aswr, ind) in question.answers"
                :class="{
                  wrong: (aswr.text.toLowerCase() !== aswr.correct.toLowerCase()) && question.answered,
                  correct: (aswr.text.toLowerCase() === aswr.correct.toLowerCase()) && question.answered
                }"
                :key="`answer-2-${ind}`"
              >
                {{ aswr.text }}&nbsp;
              </span>
            </div>
          </div>

          <div class="game-ww__question__answer__item container">
            <div class="game-ww__question__answer__item__correct container justify-content-center align-items-center">
              Correct Word
            </div>
            <div
              class="game-ww__question__answer__item__phrase__correct item container justify-content-start align-items-center">
              {{ question.answered ? question.text : '' }}
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="container align-items-center justify-content-end">
      <div class="margin-right-10 animation-fade">

        <transition name="fade">
          <gameFeedback :correct="question.hit" v-show="showFeedback"/>
        </transition>

        <div class="animation-bottom animation-delay-15 bottom-alert" v-if="question.hit && question.answered">
          <span class="correct_result">
            <i class="far fa-check-circle"></i>
            Alternativa correta
          </span>
        </div>
        <div class="animation-bottom animation-delay-15 bottom-alert" v-if="!question.hit && question.answered">
          <span class="wrong_result">
            <i class="far fa-times-circle"></i>
            Alternativa incorreta
          </span>
        </div>
      </div>
    </div>
    <modal ref="modal" v-if="!isReview" :show="showInfo" :closebtn="false" bgcolor="rgba(243, 243, 243, .95)">
      <modalSubTopic :questions="questions" :topic="topic" :subTopic="subTopic" :close="emitClose"/>
    </modal>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import { mapGetters } from "vuex";

import gameFeedback from "@/components/game/feedback";
import modal from "@/components/modal";
import modalBus from "@/components/modal/modalBus";
import modalSubTopic from "@/components/modal/modalSubTopic";
import gameBus from "@/components/game/gameBus";

export default {
  name: "WriteWordGame",
  data() {
    return {
      question: {
        answers: []
      },
      currentWord: {},
      showFeedback: false,
      ended: false,
      finished: false,
      showInfo: false,
      index: 0
    };
  },
  props: {
    topic: {
      type: Object,
      default: () => new Object()
    },
    subTopic: {
      type: Object,
      default: () => new Object()
    }
  },
  computed: {
    ...mapGetters({
      testMode: "isTestMode",
      isReview: "isReview",
      isSpeakUp: 'isSpeakUp',
      student: 'student/GET',
    }),
    questions({ subTopic }) {
      return subTopic.exercise.questions;
    },
    wordsFilled ({ currentWord, question }) {
      if (!Object.keys(currentWord).length) return false
      if (!currentWord.text) return false
      for (const aswr of question.answers) {
        if (!aswr.text) return false
      }
      return true
    }
  },
  components: {
    gameFeedback,
    modal,
    modalSubTopic
  },
  methods: {
    setCurrent () {
      let qst = {};
      for (const index in this.questions) {
        qst = this.questions[index];
        this.index = index;
        if (!this.questions[index].answered) {
          break;
        } else if (parseInt(index) === this.questions.length - 1) {
          this.ended = true;
          break;
        }
      }
      if (
        Object.keys(this.question).length == 0 ||
        qst._id !== this.question._id
      ) {
        qst.answers = qst.text
          ? qst.text
              .replace('-', ' ')
              .replace(/[^a-zA-Z0-9?\d\s:]/g, "")
              .toLowerCase()
              .split(" ")
              .map(w => ({ correct: w, text: "" }))
          : [];
        if (!qst.answered) qst.answers = qst.answers;
        this.$set(this, "question", qst);
        this.setWord();
      }

      setTimeout(() => {
        gameBus.$emit("setEnabled", this.question.answered);
      }, 1000)
    },
    setWord () {
      if (!this.question.answers) this.currentWord = { correct: "", text: "" };
      else {
        for (const index in this.question.answers) {
          const word = this.question.answers[index];

          if (!word.text) {
            this.currentWord = word;
            this.setLetters();
            if (index == this.question.answers.length - 1) this.finished = true;
            break;
          }
        }
      }
    },
    setLetters () {
      if (!this.currentWord.letters) {
        const possibilities = "abcdefghijklmnopqrstuvwxyz",
          currentWordLetters = this.currentWord.correct
            ? this.currentWord.correct
                .split('')
                .map(l => ({ letter: l, selected: false }))
            : [],
          letters = [...currentWordLetters];

        while (letters.length < 13) {
          const randChar = possibilities.charAt(
            Math.floor(Math.random() * possibilities.length)
          );
          if (!letters.includes(randChar))
            letters.push({ letter: randChar, selected: false });
        }

        this.$set(this.currentWord, "letters", this.$shuffle(letters));
      }
    },
    chooseLetter (letter) {
      if (!letter.selected && !this.question.answered)  {
        if (!this.currentWord.text) this.$set(this.currentWord, "text", "");
        this.currentWord.text = `${this.currentWord.text}${letter.letter}`;
        this.$set(letter, "selected", true);
      }
    },
    clearWord () {
      this.$set(this.currentWord, "text", "");
      for (let l of this.currentWord.letters) {
        l.selected = false;
      }
    },
    async answer () {
      this.$set(this.question, "answered", true);
      let correct = true;
      for (const aswr of this.question.answers) {
        if (aswr.text.toLowerCase() !== aswr.correct.toLowerCase()) {
          correct = false;
          break;
        }
      }
      this.question.hit = correct
      this.feedback();
      await this.save(this.question)
    },
    async feedback () {
      this.showFeedback = true;
      if (this.showFeedback) {
        await this.$delay(1500);
        this.showFeedback = false;
        gameBus.$emit("setEnabled", true);
      }
    },
    async save (question) {
      let scoreQuestions = 0,
          answered       = 0

      for (const qst of this.questions) {
        if (qst.answered) {
          if (qst.hit) scoreQuestions++
          answered++;
        }
      }

      const score = (scoreQuestions * 100) / this.questions.length

      let payload = {
        points: score,
        finished: false,
        question: { ...question }
      };

      if (answered == this.questions.length) {
        payload.finished = true;
        this.ended = true;
        await this.$delay(1500);
        this.showInfo = true;
      }

      gameBus.$emit("updateProgress", score);

      if (!!this.student.teens) {
        await this.$store.dispatch('teens/answerQuestion', payload)
        return
      }

      if (this.isSpeakUp) {
        await this.$store.dispatch("speakup/answerQuestion", {
          ...this.$route.params,
          ...payload
        })
        return
      }

      if (!this.testMode && !this.isReview)
        await this.$store.dispatch("subTopic/answerQuestion", payload);
    },
    closeModal () {
      this.showInfo = false;
    },
    emitClose () {
      this.$refs["modal"].close();
    },
    async viewQuestion (index) {
      const question = this.questions[index];
      if (question && question.answered) {
        this.index = index;
        this.$set(this, "question", question);

        if (!this.question.answers) {
          this.question.answers = this.question.text
            ? this.question.text
                .replace('-', ' ')
                .replace(/[^a-zA-Z0-9?\d\s:]/g, "")
                .toLowerCase()
                .split(" ")
                .map(w => ({ correct: w, text: "" }))
            : [];

          this.setWord();
        }
      }
    }
  },
  watch: {
    testMode (val) {
      this.setCurrent();
    },
    ended (val) {
      gameBus.$emit("setEnded", val);
    },
    index (val) {
      gameBus.$emit("updateIndex", val);
    }
  },
  beforeMount () {
    this.setCurrent();
    gameBus.$on("viewQuestion", this.viewQuestion);

    gameBus.$emit("updateProgress", this.subTopic.points);
    modalBus.$on("close", this.closeModal);
    gameBus.$on("setCurrent", this.setCurrent);
  },
  beforeDestroy () {
    gameBus.$off("viewQuestion", this.viewQuestion);

    modalBus.$off("close", this.closeModal);
    gameBus.$off("setCurrent", this.setCurrent);
  }
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/components/selectQuestion";
@import "./src/assets/css/components/answerSelectQuestion";
@import "./src/assets/css/components/writeWord";


</style>



// WEBPACK FOOTER //
// src/components/game/writeWord.vue